import { authService, intentService, feedbackService, runConfigService } from '@xpanse/ui';

import axios from 'src/lib/axios';

// --------------------- Upload APIs -----------------------------
interface GetPresignedUrlRequest {
  filename: string;
  file_metadata: Record<string, any>;
}

interface FileStatusUpdateRequest {
  status: string;
  extension: string;
  size: number;
  file_metadata: Record<string, any>;
}

// This function is used to get the presigned URL from the backend
export const getPresignedUrl = async (
  intentId: string | null | undefined,
  data: GetPresignedUrlRequest,
  controller: AbortController
) => {
  const response = await axios.post(`/intents/${intentId}/file/upload`, data, {
    signal: controller.signal,
  });
  return response.data;
};

// This function is used to upload the file to S3
export const uploadToS3 = async (presignedUrl: string, file: File, controller: AbortController) => {
  const response = await axios.put(presignedUrl, file, {
    headers: {
      'Content-Type': 'application/octet-stream',
    },
    signal: controller.signal,
  });
  return response.status === 200 ? 'UPLOADED' : 'FAILED';
};

// This function is used to update the file status in the backend
export const updateFileStatus = async (
  intentId: string | null | undefined,
  fileId: string,
  data: FileStatusUpdateRequest,
  controller: AbortController
) => {
  const response = await axios.patch(`/intents/${intentId}/file/${fileId}`, data, {
    signal: controller.signal,
  });
  return response.status;
};

// Initialize services with the configured axios instance
const AuthService = authService(axios);
const FeedbackService = feedbackService(axios);
const RunConfigService = runConfigService(axios);
const IntentService = intentService(axios);

// Export initialized services for use throughout the codebase
export { AuthService, IntentService, FeedbackService, RunConfigService };
